// Dependencies
import { Component } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';

import { bindActionCreators, Dispatch } from 'redux';
import { analysisData } from 'services/profile';
import { searchIds } from 'services/search';
import {
    SetErrorHandlerAction,
    setErrorHandlerAction,
    SetSystemLoadingAction,
    setSystemLoadingAction,
    ShowMessageAction,
    showMessageAction,
} from 'store/actions/errorsActions';
import {
    SetLayoutAction,
    setLayoutAction,
    setProfileControlsAction,
    SetProfileControlsAction,
} from 'store/actions/layoutActions';
import { ChainageType, Layout, OpenModal, PortType, ProfileDataType, RootState, TransitType } from 'types';
import {
    CheckProfileInterface,
    GetProfileDataInterface,
    MainControlsInterface,
    MapControlsInterface,
    SearchControlsInterface,
    SetProfileDataInterface,
    VoidInterface,
} from 'types/functions';
import { FilterObjectType } from 'types/search';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { checkDifferent, checkLayoutDifferent, clone, getId } from 'utils/formHandlers';
import { formatFilterObject } from 'utils/migrations';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

import LoaderSpinner from 'components/atoms/LoaderSpinner';
import { OPRN_PROFILE_WITHOUT_SEARCH } from 'data/static';
import { PortState } from 'store/reducers/portReducer';
import ProfileChart from './ProfileChart';

interface ProfileComponentProps {
    active: boolean;
    portData: PortState;
    setLayoutAction: SetLayoutAction;
    layout: Layout;
    setProfileControlsAction: SetProfileControlsAction;
    searchObject: FilterObjectType;
    port: PortType;
    dateTimeFormat: DateTimeFormat;
    setErrorHandlerAction: SetErrorHandlerAction;
    showMessageAction: ShowMessageAction;
    setSystemLoadingAction: SetSystemLoadingAction;
    openModelFunction: OpenModal;
    searchControls: SearchControlsInterface;
    mainControls: MainControlsInterface;
    mapControls: MapControlsInterface;
}

interface ProfileComponentState {
    active: boolean;
    layout: Layout;
    openMenu?: boolean;

    profileComplated: boolean;
    sourceSearchObject: FilterObjectType;
    searchObject: FilterObjectType;
    analysisData: ProfileDataType | null;
    unit: string;
    transits: number[];
    results: any;
    exportFunctions: VoidInterface[];
    chainage: ChainageType[];
    histogramIndex: number | null;
    profileId: string;
    outmodedData: boolean;
    loading: boolean;
    searchId: string;
}

class Profile extends Component<ProfileComponentProps, ProfileComponentState> {
    constructor(props: ProfileComponentProps) {
        super(props);
        this.state = {
            unit: 'point',
            transits: [],
            chainage: [],
            layout: clone(props.layout),
            active: false,
            openMenu: props.layout.openMenu,
            exportFunctions: [],
            profileComplated: false,
            analysisData: null,
            sourceSearchObject: clone(props.searchObject),
            searchObject: clone(props.searchObject),
            results: null,
            histogramIndex: null,
            profileId: '',
            outmodedData: false,
            loading: false,
            searchId: '',
        };
    }

    static getDerivedStateFromProps(props: ProfileComponentProps, state: ProfileComponentState) {
        if (checkLayoutDifferent(props.layout, state.layout, ['sections.profile', 'searchId', 'openMenu'])) {
            return {
                active: props.active,
                layout: clone(props.layout),
                openMenu: props.layout.openMenu,
            };
        }
        if (props.active !== state.active) {
            return {
                active: props.active,

                layout: clone(props.layout),
                openMenu: props.layout.openMenu,
            };
        }
        return null;
    }

    componentDidMount(): void {
        this.props.setProfileControlsAction({
            checkProfile: this.checkProfile,
            getProfileData: this.getProfileData,
            setProfileData: this.setProfileData,
            clearProfileData: this.clearProfileData,
            profile: this.profile,
            exportProfile: this.runExportFunction,
            updateProfile: this.updateProfile,
        });
    }

    componentDidUpdate(
        prevProps: Readonly<ProfileComponentProps>,
        prevState: Readonly<ProfileComponentState>,
        snapshot?: any
    ): void {
        const { status, outmodedData, message, messageType, searchDefined, transits } = this.checkProfile();

        if (
            this.state.outmodedData !== outmodedData &&
            outmodedData &&
            searchDefined &&
            this.state.active &&
            this.state.profileId !== ''
        ) {
            this.props.openModelFunction(
                'profileDataUpdatedModel',
                0,
                'medium',
                {},
                {
                    onConfirm: () => {
                        this.setState(
                            {
                                outmodedData: outmodedData,
                            },
                            () => {
                                this.updateProfile(true);
                            }
                        );
                    },
                    onCancel: () => {
                        this.setState({
                            outmodedData: outmodedData,
                        });
                        this.props.openModelFunction('profileDataUpdatedModel');
                    },
                }
            );
        }
    }

    getProfileData: GetProfileDataInterface = () => {
        return {
            results: this.state.results,
            analysisData: this.state.analysisData,
            transits: this.state.transits,
            histogramIndex: this.state.histogramIndex,
            profileId: this.state.profileId,
        };
    };

    updateProfile = (force = false) => {
        if (!force && !this.state.layout.sections.profile.tools.updateAnalysis.active) {
            return;
        }
        this.props.openModelFunction(
            'profileOptionsModel',
            0,
            'medium',
            { ...this.state.analysisData, unit: this.state.unit },
            {
                onCancel: () => {
                    this.props.openModelFunction('profileOptionsModel');
                },
                onConfirm: () => {
                    //console.log('saved')
                },
            },
            true
        );
    };

    runExportFunction = () => {
        if (!this.state.layout.sections.profile.tools.exportAnalysis.active) {
            return;
        }
        this.state.exportFunctions.forEach((x) => {
            x();
        });
    };

    clearProfileData: VoidFunction = () => {
        this.setState({
            searchObject: clone(this.props.searchObject),
            profileId: getId(),
            results: {},
            transits: [],
            exportFunctions: [],
            loading: false,
        });
    };

    setProfileData: SetProfileDataInterface = (analysisData, chainage, unit) => {
        this.setState(
            {
                searchObject: clone(this.props.searchObject),
                analysisData: analysisData,
                profileId: getId(),
                chainage: chainage,
                unit: unit,

                results: {},
                exportFunctions: [],
                loading: true,
            },
            this.profile
        );
    };

    profile: VoidInterface = () => {
        const searchNumbers = this.props.searchControls.getSearchObjectNumbers();
        if (searchNumbers) {
            const { transits } = this.props.mainControls.getTransit(0);
            this.setState(
                {
                    outmodedData: false,
                    transits: transits
                        .filter((x: TransitType) => {
                            return x.options.select && x.options.display;
                        })
                        .map((x) => {
                            return x.id;
                        }),
                    profileId: getId(),
                    profileComplated: true,
                    searchId: this.props.layout.searchId,
                },
                () => {
                    this.analysisDataTry(
                        this.state.transits,
                        'json',
                        //@ts-ignore
                        { ...this.state.analysisData, unit: this.state.unit },
                        this.state.profileId,
                        0
                    );
                }
            );
            return;
        }

        this.setState({ loading: true });
        searchIds(
            'search',
            this.props.port.id,
            formatFilterObject(this.props.searchObject, this.props.port.backEnd?.version, this.props.portData)
        )
            .then((res) => {
                this.setState(
                    {
                        outmodedData: false,
                        transits: this.props.port.backEnd?.version !== 2 ? res.items : res.transits,
                        profileComplated: true,
                        searchId: this.props.layout.searchId,
                    },
                    () => {
                        this.analysisDataTry(
                            this.state.transits,
                            'json',
                            //@ts-ignore
                            { ...this.state.analysisData, unit: this.state.unit },
                            this.state.profileId,
                            0
                        );
                    }
                );
            })
            .catch((error) => {
                // this.props.setSystemLoadingAction(false);
                this.setState({ loading: false });
                this.props.setErrorHandlerAction(error);
            });
    };

    analysisDataTry = (transits: number[], request: string, data: ProfileDataType, id: string, retry: number) => {
        analysisData(this.props.port.id, {
            transits: transits,
            request: request,
            analysisData: data,
            retry: retry,
            id: id,
        })
            .then((res) => {
                this.setState(
                    {
                        analysisData: data,
                        results: res.items,
                        loading: false,
                        outmodedData: false,
                        searchId: this.props.layout.searchId,
                    },
                    () => {
                        this.props.setLayoutAction([
                            {
                                action: 'UPDATE_TOOLS',
                                data: {
                                    section: 'profile',
                                    names: ['exportAnalysis'],
                                    active: true,
                                },
                            },
                        ]);
                        this.props.setSystemLoadingAction(false);
                    }
                );
            })
            .catch((error) => {
                if (retry < 5 && (error?.response?.status === 504 || error.code === 'ERR_NETWORK')) {
                    if (retry === 0) {
                        this.props.showMessageAction({
                            messageType: 'INFO',
                            message: translate(`Preparing data will take some time please wait.`),
                        });
                    }
                    this.analysisDataTry(transits, request, data, id, retry + 1);
                } else {
                    if (error?.response?.status === 504 || error.code === 'ERR_NETWORK') {
                        this.props.setSystemLoadingAction(false);
                        this.props.showMessageAction({
                            messageType: 'ERROR',
                            message: translate(`Couldn't complete this profile`),
                        });
                    } else {
                        this.setState({ loading: false });
                        this.props.setSystemLoadingAction(false);
                        this.props.setErrorHandlerAction(error);
                    }
                }
            });
    };

    checkProfile: CheckProfileInterface = () => {
        const { transits } = this.props.mainControls.getTransit(0);

        const outmodedData = OPRN_PROFILE_WITHOUT_SEARCH
            ? this.props.layout.searchId !== this.state.searchId
            : checkLayoutDifferent(
                  transits
                      .filter((x: TransitType) => {
                          return x.options.select && x.options.display;
                      })
                      .map((x) => {
                          return x.id;
                      }),
                  this.state.transits
              ) && this.state.transits.length !== 0;

        if (
            !checkDifferent(this.props.searchObject, this.state.sourceSearchObject) &&
            this.props.searchObject.limit === 0
        ) {
            if (OPRN_PROFILE_WITHOUT_SEARCH) {
                return {
                    status: true,
                    mesage: '',
                    outmodedData: outmodedData,
                    messageType: '',
                    searchDefined: false,
                    transits,
                };
            }
            return {
                status: false,
                message: translate('No search defined. please define a search before attempting profile'),
                messageType: 'ERROR',
                searchDefined: false,
                outmodedData: outmodedData,
                transits,
            };
        }

        if (!this.state.profileComplated) {
            return { status: true, mesage: '', outmodedData: false, messageType: '', searchDefined: true, transits };
        }

        return { status: null, mesage: '', outmodedData: outmodedData, messageType: '', searchDefined: true, transits };
    };

    getHistogram = (index: number) => {
        this.setState({ histogramIndex: index }, () => {
            this.props.openModelFunction(
                'profileHistogramModel',
                0,
                '',
                {
                    results: this.state.results,
                    analysisData: this.state.analysisData,
                    transits: this.state.transits,
                    histogramIndex: this.state.histogramIndex,
                    profileId: this.state.profileId,
                    handleHistogramIndex: (histogramIndex) => this.handleHistogramIndex(histogramIndex),
                },
                {
                    onCancel: () => {
                        this.props.openModelFunction('profileHistogramModel');
                    },
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    onConfirm: () => {},
                },
                true
            );
        });
    };

    handleHistogramIndex = (histogramIndex) => {
        this.setState({ histogramIndex });
    };

    addExportFunction = (fn) => {
        this.state.exportFunctions.push(fn);
        this.setState({ exportFunctions: this.state.exportFunctions });
    };

    render() {
        // eslint-disable-next-line no-unsafe-optional-chaining
        const { name } = this.props?.mapControls?.chart?.portAreaFeatureVisiblity(
            this.state.analysisData?.pilotagePlanAnalysis?.pilotagePlan?.route || '',
            'route'
        ) || { name: '' };

        return (
            <div
                className={twclsx(
                    !this.state.active && 'hidden',
                    'mt-14',
                    'h-page',

                    'padding-transition',
                    'fixed',
                    'z-10',
                    'left-0',
                    'right-0',
                    'margin-transition',
                    this.state.openMenu ? 'xl:ml-menu md:ml-14 xl:w-main md:w-fullPage' : 'ml-14 w-fullPage'
                )}
            >
                <div className="p-2 h-10 flex justify-start  gap-2 border-b border-gray-300 ">
                    {this.state.layout.searchId === '' ? (
                        <div>{translate('No search defined. please define a search before attempting profile')}</div>
                    ) : this.state.transits.length === 0 ? (
                        <div className="text-primary-link capitalize cursor-pointer"></div>
                    ) : (
                        <>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: translate('profile analysis title', {
                                        transits: this.state.transits.length,
                                        route: name,
                                    }),
                                }}
                            ></div>
                            {this.state.outmodedData && (
                                <div className="text-yellow-500 font-bold">
                                    {translate('The data is outmoded. Please update the profile options.')}
                                </div>
                            )}
                        </>
                    )}

                    <div></div>
                </div>
                <Scrollbars
                    renderThumbHorizontal={() => <div style={{ display: 'none' }} />}
                    renderTrackHorizontal={() => <div style={{ display: 'none' }} />}
                    style={{
                        height: 'calc( 100vh - 96px)',
                    }}
                >
                    {this.state.loading ? (
                        <LoaderSpinner />
                    ) : (
                        this.state.results?.pilotagePlanAnalysis && (
                            <div className="px-4 mt-3">
                                <div className="grid grid-cols-1 gap-y-3">
                                    {Object.keys(this.state.results.pilotagePlanAnalysis).map((item, i) => {
                                        return (
                                            <div key={i}>
                                                <ProfileChart
                                                    getHistogram={this.getHistogram}
                                                    addExportFunction={this.addExportFunction}
                                                    chainage={this.state.chainage}
                                                    for={item}
                                                    transits={this.state.transits}
                                                    analysisData={this.state.analysisData}
                                                    data={this.state.results.pilotagePlanAnalysis[item]}
                                                ></ProfileChart>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )
                    )}
                </Scrollbars>
            </div>
        );
    }
}

const profileStateToProps = (state: RootState) => ({
    layout: state.layout.layout,
    searchObject: state.layout.searchObject,
    port: state.port.port,
    portData: state.port,
    dateTimeFormat: state.port.dateTimeFormat,
    openModelFunction: state.layout.openModelFunction,
    searchControls: state.layout.searchControls,
    mainControls: state.layout.mainControls,
    mapControls: state.map.mapControls,
});

const profileDispatchToProps = (dispatch: Dispatch) => ({
    setSystemLoadingAction: bindActionCreators(setSystemLoadingAction, dispatch),
    setProfileControlsAction: bindActionCreators(setProfileControlsAction, dispatch),
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
    showMessageAction: bindActionCreators(showMessageAction, dispatch),
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(profileStateToProps, profileDispatchToProps)(Profile);
